import { _, React, Component, Container } from 'utils';
import { Creators, AreaStore as Store, ActiveStore } from 'model';
import Tag from '../search/Tag';
import './style.less';
import { BaseSearch } from '../search/Search';
import { BaseSuggestions } from '../search/suggestions/component';

class PSuggestions extends BaseSuggestions {
	static getStores() {
		return [Store];
	}

	static calculateState(state, props) {
		var state = Store.getState();

		return {
			recommendations: Store.getRecommendations(),
			visible: state.visible,
			active: state.active,
			onSelect: props.onSelect
		}
	}
}

const PositionSuggestions = Container.create(PSuggestions, { withProps: true });

class PSearch extends BaseSearch {
	static getStores() {
		return [ActiveStore, Store];
	}

	static calculateState(state, props) {
		var state = Store.getState();

		return {
			query: Store.getQuery(),
			filter: state.selected,
			visible: state.visible,
			filters: ActiveStore.getState().filters,
			type: state.type,
			description: props.description,
			onFind: Creators.queryChanged,
			onNext: Creators.nextSuggestion,
			onPrevious: Creators.previousSuggestion,
			onSelect: Creators.selectSuggestion,
			onBlur: Creators.blur,
			mode: ActiveStore.getState().filters.length == 0?'search':'add',
			store: props.store,
			filterDescription: props.filterDescription
		}
	}

	renderSuggestions() {
		return <PositionSuggestions onSelect={ this.handleSelect } />
	}
}

const PositionSearch = Container.create(PSearch, { withProps: true });

export default class AreaFilters extends Component {

	render() {
		return <div className="type-filters">
			<PositionSearch store="area" description="Unesite županiju" filterDescription="Dodajte županiju" />
		</div>;
	}

}



// WEBPACK FOOTER //
// ./src/modules/app/filters/Area.js